import React from 'react';
import Input from '@creditflowresearch/uilib/Input';
import IconEmail from '@creditflowresearch/uilib/Icon/IconEmail';
import { IFinalFormFieldInputComponentProps } from '@framework/ui/Organisms/FinalForm/interfaces';

interface IProps extends IFinalFormFieldInputComponentProps {
  className?: string,
  placeholder?: string,
  dataTest: string,
}

const EmailInput = ({
  className,
  placeholder = 'Email',
  dataTest,
  ...props
}: IProps) => (
  <Input
    type="email"
    name="email"
    placeholder={ placeholder }
    icon={ IconEmail }
    className={ className }
    dataTest={ dataTest }
    { ...props }
  />
);

export default EmailInput;
